// extracted by mini-css-extract-plugin
export default {"container":"Toggle_container__DgJeO","switch":"Toggle_switch__NN4Cp"};